

export class VehicleAlertListOutputDataData implements IVehicleAlertListOutputDataData {
    /** The server time GMT Based */
    servertime!: string;
    /** The vehicle details */
    vehicle!: string;
    /** The alert type */
    alert_name!: string;
    /** The alert message */
    alert_information!: string;
    /** The latitude of selected place */
    latitude!: number;
    /** The longitude of selected place */
    longitude!: number;

    constructor(data?: IVehicleAlertListOutputDataData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servertime = _data["servertime"];
            this.vehicle = _data["vehicle"];
            this.alert_name = _data["alert_name"];
            this.alert_information = _data["alert_information"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): VehicleAlertListOutputDataData {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleAlertListOutputDataData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servertime"] = this.servertime;
        data["vehicle"] = this.vehicle;
        data["alert_name"] = this.alert_name;
        data["alert_information"] = this.alert_information;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }
}

export interface IVehicleAlertListOutputDataData {
    /** The server time GMT Based */
    servertime: string;
    /** The vehicle details */
    vehicle: string;
    /** The alert type */
    alert_name: string;
    /** The alert message */
    alert_information: string;
    /** The latitude of selected place */
    latitude: number;
    /** The longitude of selected place */
    longitude: number;
}

